import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { supplierOfficeRecordQuery } from "@/app/Offices/GraphQL/supplierOfficeRecordQuery";
import { UpdateSupplierOfficeInput } from "@/gql/graphql";
import { updateSupplierOfficeMutation } from "@/app/Offices/GraphQL/supplierOfficeMutations";
import { OfficeNotificationForm } from "@/app/Offices/Forms/OfficeNotificationForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";

export function OfficeNotificationDialog({ officeId }: { officeId: string }) {
  const { data } = useSuspenseGqlQuery(supplierOfficeRecordQuery, {
    id: officeId,
  });

  const record = data.supplierOffice;
  const { mutateAsync } = useGqlMutation(updateSupplierOfficeMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog
      title="Notifications"
      subtitle="Send notifications to this office when a booking is created"
    >
      <GenericForm<UpdateSupplierOfficeInput>
        onSubmit={async (values) => {
          await mutateAsync({
            id: officeId,
            input: values,
          });

          await close();
        }}
        initialValues={{
          booking_email: record.booking_email,
          cc_booking_to_departure_office: record.cc_booking_to_departure_office,
        }}
      >
        <OfficeNotificationForm />
        <DialogSubmitButton text="Update office" />
      </GenericForm>
    </BaseDialog>
  );
}
